import { render, staticRenderFns } from "./PepViewCard.vue?vue&type=template&id=78638a8c&"
import script from "./PepViewCard.vue?vue&type=script&lang=js&"
export * from "./PepViewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports